import { Snackbar, Alert, IconButton } from "@mui/material";
import {
  Close as CloseIcon,
  CheckCircle as SuccessIcon,
  ErrorOutline as ErrorOutlineIcon,
} from "@mui/icons-material";

export default function CustomSnackbar({ isOpen, message, success, onClose }) {
  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        severity={success ? "success" : "error"}
        icon={
          success ? (
            <SuccessIcon fontSize="inherit" />
          ) : (
            <ErrorOutlineIcon fontSize="inherit" />
          )
        }
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
